export default __webpack_public_path__ + "static/Recorrido-virtual-arquitectonico3-79ece0a28d54289b36d8638fd883ae52.jpg";